export const BITS_PER_DATA = 7;
export const DATA_RANGE = 2 ** BITS_PER_DATA;
export const DATA_RANGE_WITH_LSB = DATA_RANGE ** 2;
export const PITCH_BEND_NEUTRAL = DATA_RANGE_WITH_LSB / 2;
